export const deleteButtonStyles = {
  backgroundColor: "#EB7179",
  borderRadius: "100px",
  borderStyle: "none",
  color: "white",
  padding: "12px 50px",
  cursor: "pointer",
};

export const cancelDeleteButtonStyles = {
  borderRadius: "10rem",
  border: "hidden",
  position: "absolute",
  top: "-0.5rem",
  right: "-0.5rem",
  backgroundColor: "#161B1E",
  color: "#FFF",
  height: "1.3rem",
  width: "1.3rem",
};

/*export const cancelDeleteButtonStyles = {
  borderRadius: "100px",
  border: "hidden",
  position: "absolute",
  top: "2px",
  right: "2px",
  backgroundColor: "#161B1E",
  color: "#FFF",
};*/

export const filterClassButtonStyle = {
  width: 'fit-content',
  borderStyle: 'none',
  borderRadius: '1rem',
  color: 'black',
  backgroundColor: '#FFF',
  border: '2px solid black',
  padding: '0.5rem',
  margin: '0.2rem 0.1rem',
  outline: 'none',
};

export const filterClassButtonSelectedStyle = {
  width: 'fit-content',
  borderStyle: 'none',
  borderRadius: '1rem',
  color: 'white',
  border: '2px solid black',
  backgroundColor: '#161B1E',
  padding: '0.5rem',
  margin: '0.2rem 0.1rem',
  outline: 'none',
};

export const tagButtonStyle = {
  borderStyle: 'none',
  borderRadius: '1rem',
  color: 'black',
  backgroundColor: '#FFF',
  border: '2px solid black',
  padding: '0.5rem',
  margin: '0.2rem 0.1rem',
  outline: 'none',
  wordBreak: 'break-word',
};

export const tagButtonSelectedStyle = {
  borderStyle: 'none',
  borderRadius: '1rem',
  color: 'white',
  border: '2px solid black',
  backgroundColor: '#161B1E',
  padding: '0.5rem',
  margin: '0.2rem 0.1rem',
  outline: 'none',
  wordBreak: 'break-word',
};

export const boxShadow = 'rgba(0, 0, 0, 0.12) 0 8px 6px -6px inset';
